module.exports = __webpack_public_path__ + "img/montageschulung_mit_wdk_Zertifizierung_784x514.9fd4253d.png";